/**
 * 15_MOTION §7 고정 시드 회전.
 * 같은 스탬프는 언제 봐도 같은 각도여야 한다. 다시 볼 때마다 바뀌면 기록이 아니라 버그로 보인다.
 */
export function stableRotation(id: string, maxDeg: number): number {
  let h = 0;
  for (let i = 0; i < id.length; i += 1) h = (h * 31 + id.charCodeAt(i)) | 0;
  return ((Math.abs(h) % 2001) / 1000 - 1) * maxDeg;
}

/** 회전 각도 상한. 13_DESIGN_CONCEPT §3 C3. */
export const ROTATION_MAX = {
  sticker: 1.5,
  tape: 1.5,
  stamp: 6,
  countryStamp: 4,
} as const;
